import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { AgendaService } from '../services/agenda.service';
import { EmpresaTreeViewService } from '../../employee/services/empresa-treeView.service';
import { EmployeeService } from '../../employee/services/employee.service';
import { Router } from '@angular/router';
import { TaskSaveService } from '../../task/services/task-save.service';
import { TareaViewModel, TareasDateRangeCount } from 'app/modules/task/entities/Tarea';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
    selector: 'app-tasks',
    templateUrl: './tasks.component.html',
    styleUrls: ['./tasks.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TasksComponent implements OnInit {

  public empresaId: number;
  today = new Date();
  tasks: TareaViewModel[] = [];
  selectedTab: any;
  dateTaskCount: TareasDateRangeCount[] = [];
  selectedIndex = 2;
  defaultIndex = 2;

  public dataSource = new MatTableDataSource<any>();
  paginator: MatPaginator;
  @ViewChild(MatPaginator, { static: false }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  public displayedColumns = ['iconSrc', 'fecha', 'tarea', 'empresa', 'name', 'action'];
  @ViewChild(MatTabGroup) matTabGroup: MatTabGroup;
  tabLabelList: any = [];

  constructor(
    public empresaTreeViewService: EmpresaTreeViewService,
    public agendaService: AgendaService,
    private employeeService: EmployeeService,
    public taskService: TaskSaveService,
    private router: Router,
    private sharedService: SharedService
  ) {
    this.loadTabLable();
    // Get Empresa Id when changing the Selected company 
    this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
      this.empresaId = _res;
      if (this.empresaId > 0) {
        this.tasks = [];
        this.getSelectedTabData(this.defaultIndex, this.selectedTab);
        this.agendaService.setTareasCount(this.empresaId);
      }
    });
    // Get Date Task Count for the Selected company 
    this.agendaService.DateTaskCount.subscribe((_res: any) => {
      const tempDateCount = _res;
      if (tempDateCount.length > 0 && tempDateCount !== undefined) {
        this.dateTaskCount = _res;
      }
    });
    this.taskService.refershTabList.subscribe(() => {
      this.getSelectedTabData(this.selectedIndex, this.selectedTab);
      this.agendaService.setTareasCount(this.empresaId);
    });
  }

  setDataSourceAttributes(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.empresaId = JSON.parse(localStorage.getItem('Empresa'));
    this.agendaService.setTareasCount(this.empresaId);
    this.taskService.setPermissionForContextMenu();
  }

  ngAfterContentInit(): void {
    this.getSelectedTabData(this.defaultIndex, this.selectedTab);
  }

  loadTabLable(): void {
    this.tabLabelList = [
      { id: 0, label: 'Anteriores', paramValue: 'DayBefore' },
      { id: 1, label: 'Ayer', paramValue: 'Yesterday' },
      { id: 2, label: 'Hoy', paramValue: 'Today' },
      { id: 3, label: 'Mañana', paramValue: 'Tomorrow' },
      { id: 4, label: 'Posteriores', paramValue: 'DayAfter' }
    ];
    this.selectedTab = this.tabLabelList[2];
    this.defaultIndex = 2;
  }

  onTabChange($event): void {
    const tab = $event;
    this.selectedIndex = tab.index;
    this.selectedTab = tab.tab._viewContainerRef._view.context.$implicit;
    this.getSelectedTabData(tab.index, this.selectedTab);
  }

  getSelectedTabData(index, selectedTab: any): void {
    this.selectedIndex = index;
    const today = new Date();
    let tempBody: any;
    this.agendaService.getTareasData(this.empresaId, today, selectedTab.paramValue).then(
      res => {
        tempBody = res;
        this.tasks = tempBody.result;
        this.dataSource = new MatTableDataSource();
        this.dataSource.data = this.tasks;
        this.paginator.length = this.tasks.length;
        this.paginator.pageIndex = 0;
        this.dataSource.paginator = this.paginator;
        this.dataSource._updatePaginator(this.tasks.length);
      }
    );
  }

  NameClicked(data: any): void {
    this.employeeService.userSelected(data);
  }

  public NavigateToTaskSelection(): void {
    if (this.sharedService.selectionTabList.filter(e => e.id === 5 && e.isPermit).length > 0) {
      this.sharedService.selectedSelectionTabId = 5;
      this.router.navigate(['/selection-view']);
    } else {
      this.sharedService.ShowSnackBar('Permission denied', '', 2500);
    }
  }
}
